const expensesGA4 = require('./expenses/expenses.json');
const approvalsGA4 = require('./approvals/approvals.json');
const reportsGA4 = require('./reports/reports.json');
const cardsGA4 = require('./cards/home-page.json');
const newsGA4 = require('./others/news.json');
const adminReportsGA4 = require('./admin-reports/admin-reports.json');
const financialGA4 = require('./financial/financial.json');
const monitoringReportGA4 = require('./management-reports/monitoring_report.json');
const notificationsGA4 = require('./notifications/notifications.json');
const analysisGA4 = require('./analysis/analysis.json');
const upliftGA4 = require('./others/uplift.json');

// Array contendo todos os eventos genericos
const ga4Data = [
  expensesGA4,
  approvalsGA4,
  reportsGA4,
  cardsGA4,
  newsGA4,
  adminReportsGA4,
  financialGA4,
  monitoringReportGA4,
  notificationsGA4,
  analysisGA4,
  upliftGA4,
];

const hoverEventsId = ['approvals_hoverTableItemHelper', 'reports_hoverAdvancement'];

/**
 * Aplica os listeners necessários para o ga4
 */
function applyGoogleAnalyticsEvents() {
  applyGenericEvents();
}


/**
 * Verifica se algum erro foi disparado para modificar o evento do ga4
 */
function hasError(element) {
  if (!element) { return false; }

  // Todo input deveria ter um form group se for validado por padrão
  // Quando um erro ocorre o pai do input sempre vai ter a classe has error
  if (element.parent().hasClass('has-error')) {
    return true;
  }
  // Validação de erro para o elemento de anexo de observação nos modais
  if (element.siblings('.text-error').is(':visible')) {
    return true;
  }

  return false;
}


/**
 * Retorna uma validação caso o botão disparado seja um submit de um modal
 */
function validateModalForms(element) {
  if (!element) { return false; }

  const form = element.closest('form');

  if (!form.length) { return false; }

  // Se tiver um form e não for valido retorna uma flag de erro
  if (!form.valid()) {
    return true;
  }
}

/**
 * Retorna o valor dinamico para cada tipo de elemento input
 */

function getEventValue(element) {
  if (!element || !element.is(':input')) { return '0'; }

  if (element.is('div')) {
    return element.text();
  }

  if (element.is('select')) {
    return element.text();
  }

  if (element.is(':checkbox') || element.is(':radio')) {
    return element.is(':checked') ? '1' : '0';
  }

  return element.val();
}

/**
 * Mapeia os itens dos eventos do json para os respectivos elementos
 * Todos os itens mapeados devem ter a propriedade  data-ga4-id nos elementos html
 * Os dados carregados devem seguir a estrutura padrão dos abjetos.
 */
function applyGenericEvents() {
  ga4Data.map(data => {
    Object.entries(data).map(([id, item]) => {

      const eventProduct = window.location.pathname.replace('/', '');

      // Os eventos da tela de despesa podem ocorrer na tela de relatórios
      // Para identificar eles e evitar eventos repetidos é atualizado qual tela estamos
      if ((eventProduct === 'despesas' || eventProduct === 'relatorios') && eventProduct !== item['eventProduct']) {
        item['eventProduct'] = eventProduct;
      }

      // Se não tiver id ou começar com -
      // Se um evento começa com - ele não é generico e vai ser chamado utilizado o metodo getCustomEventCallback
      if (id === '-' || id.startsWith('-')) { return; }

      const element = $(`[data-ga4-id="${id}"]`);

      const errorItem = data[`${id}Error`];

      if (!element) { return; }

      if (hoverEventsId.includes(id)) {
        return element.on('mouseleave', function (e) {
          item['dateImplementation'] = '21/07/2023';
          window.gtag('event', item.eventName, item);
        });
      }

      if (element.is(':input:not(button, select, [type="button"])')) {
        if (element.is(':checkbox') || element.is(':radio')) {
          return element.on('click', function (event) {
            event.stopPropagation();

            if (hasError(element)) {
              // Os ids seguem um padrão de tela_funcionalidadeEstado
              // Por exemplo : expensesModal_addAttachment com erro tem o id expensesModal_addAttachmentError
              // Essas chaves contém o nome correto do evento e os outros atributos preenchidos para o componente só que com erro
              item = !!errorItem ? errorItem : item;
            }

            item['dateImplementation'] = '21/07/2023';
            item['eventValue'] = getEventValue(element);
            window.gtag('event', item.eventName, item);
          });
        }

        if (element.is('input')) {
          return element.on('change', function (event) {
            if (hasError(element)) {
              item = !!errorItem ? errorItem : item;
            }

            item['dateImplementation'] = '21/07/2023';
            item['eventValue'] = getEventValue(element);
            window.gtag('event', item.eventName, item);
          });
        }
      }

      element.on('pointerup', function (event) {
        event.stopPropagation();

        item['dateImplementation'] = '21/07/2023';
        if (validateModalForms(element) && errorItem) {
          errorItem['eventValue'] = 1;
          errorItem['dateImplementation'] = '21/07/2023';
          return window.gtag('event', errorItem.eventName, errorItem);
        }

        item['eventValue'] = 0;
        window.gtag('event', item.eventName, item);
      });
    });
  });
}

/**
 * Retorna uma chamada ao evento do gtag
 */
function getCustomEventCallback(id) {
  let callback = () => {};

  if (!id) { return callback; }

  // Atualiza o callback para disparar um push no datalayer caso o id exista no json
  ga4Data.map(data => {
    const item = data[id];
    if (!!item) {
      callback = (element) => {
        const eventProduct = window.location.pathname.replace('/', '');

        // Os eventos da tela de despesa podem ocorrer na tela de relatórios
        // Para identificar eles e evitar eventos repetidos é atualizado qual tela estamos
        if ((eventProduct === 'despesas' || eventProduct === 'relatorios') && eventProduct !== item['eventProduct']) {
          item['eventProduct'] = eventProduct;
        }

        if ($(element).length > 0) {
          item['eventValue'] = getEventValue($(element));
        }

        item['dateImplementation'] = '21/07/2023';
        window.gtag('event', item.eventName, item);
      }
    }
  });

  return callback;
}


module.exports = {
  init: applyGoogleAnalyticsEvents,
  event: getCustomEventCallback
};

